import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';

export function CenterBackground() {
  const layout = useCarouselLayout();
  const area = layout.centerArea();
  // const fill = 'rgb(252,252,252)';
  const fill = 'white';
  // const fill = 'white';
  // const fill = 'rgba(72, 192, 227, 0.2)';

  return <rect fill={fill} x={area.x1} y={area.y1} width={area.width} height={area.height} />;
}
